import styled from "styled-components"
import FadeIn from "react-fade-in"

const ListContainer = styled.section`
  background-color: ${(props) => props.theme.a_color_gradients.a_dark};
`
const StyledFade = styled(FadeIn)`
  & > div:nth-of-type(1),
  & > div:nth-of-type(3) {
    background-color: ${(props) => props.theme.a_color_gradients.a_dark};
  }
`
const BorderTaxo = styled.button`
  border: 1px solid ${(props) => props.theme.b_color_gradients.b_dark};
  color: ${(props) =>
    props.activeBool ? props.activeText : props.theme.b_color_gradients.b_dark};
  background-color: ${(props) =>
    props.activeBool ? props.theme.b_color_gradients.b_dark : props.activeText};
  &:hover {
    background-color: ${(props) =>
      props.activeBool ? null : props.theme.b_color_gradients.b_dark};
    color: ${(props) => (props.activeBool ? null : props.activeText)};
  }
  &::after {
    ${(props) =>
      props.activeBool
        ? 'content: " \\D7";margin-left: 5px;line-height: 1;'
        : ""};
  }
`

const ContainerLight = styled.section`
  background-color: initial;
`

export { ListContainer, StyledFade, BorderTaxo, ContainerLight }
